import gql from "graphql-tag";

export default gql`
  query($id: String!) {
    font(id: $id) {
      id
      family
      variants {
        variant
        file {
          url
        }
      }
    }
  }
`;
